import React, { FunctionComponent, ReactNode } from 'react';
import { ErrorBoundary } from '@sentry/react';
import { connect } from 'react-redux';
import { IAppState } from '../../common/models/store/IAppState';
import NotFound from '../../scenes/NotFound';
import { User } from '../../common/models/user/User';

interface IProps {
  children: ReactNode;
  user: User | undefined;
}

const ErrorHandler: FunctionComponent<IProps> = ({ children, user }) => (
  <ErrorBoundary
    dialogOptions={{ user: user && { name: `${user.firstName} ${user.lastName}`, email: user.email } }}
    showDialog
    fallback={({ resetError }) => <NotFound onClick={resetError} />}
  >
    { children }
  </ErrorBoundary>
);

const mapStateToProps = ({ user: { user } }: IAppState) => ({ user });

export default connect(mapStateToProps)(ErrorHandler);
